export default __webpack_public_path__ + "static/media/system_01_03.0e5e3fda.jpg";